import { FORM_TYPE_CREATE_DIRECT_FLOW } from 'js/constants/formTypes';
import UIUtils from 'js/lib/UIUtils';
import createFlowService from 'new/components/flows/service/createFlowService';
import { useCurrentOrg } from 'new/hooks/adapters/useCurrentOrg';
import useFormData from 'new/state/forms/repository/useForms';
import usePaging from 'new/state/paging/repository/usePaging';
import { withUiModeDefault } from 'new/utils/uiMode';
import useFlowType from './useFlowType';

type UseConfig = {
  sourceConfig: Record<string, any> | undefined;
  sinkConfig: Record<string, any> | undefined;
  onSinkConfigChanged(newSinkConfig: Record<string, any> | undefined, field: any, value: any): void;
  onSourceConfigChanged(data: any): void;
  onApiSourceConfigChanged(data: any): void;
};

const Form = FORM_TYPE_CREATE_DIRECT_FLOW;
const { buildSinkConfig } = createFlowService();

export default function useConfig(): UseConfig {
  const org = useCurrentOrg();
  const formData = useFormData(Form);
  const { getSourceConfigFields, getSinkConfigFields } = usePaging();
  const flowType = useFlowType();
  const { updateFormData, data = {} } = formData;
  const { selectedConnection, sourceConfig, sinkConfig } = data;

  const onSourceConfigChanged = (data: any) => {
    const fields = getSourceConfigFields(selectedConnection, flowType);
    const reducedSourceConfig = UIUtils.reduceConfig(data, fields);
    const sourceConfigWithMode = withUiModeDefault(reducedSourceConfig);

    updateFormData({
      sourceConfig: sourceConfigWithMode,
    });
  };

  const onApiSourceConfigChanged = (data: any) => {
    const apiConfigWithMode = withUiModeDefault(data);
    updateFormData({ apiConfig: apiConfigWithMode });
  };

  const onSinkConfigChanged = (newSinkConfig: any, field: any, value: any) => {
    const sinkConfigFields = getSinkConfigFields(selectedConnection, flowType);
    const sinkConfig = buildSinkConfig({
      newSinkConfig,
      sinkConfigFields,
      field,
      value,
      selectedConnection,
      orgId: org.id,
      flowType,
    });

    const reducedSinkConfig = UIUtils.reduceConfig(sinkConfig, sinkConfigFields);
    const sinkConfigWithMode = withUiModeDefault(reducedSinkConfig);

    updateFormData({ sinkConfig: sinkConfigWithMode });
  };

  return {
    sinkConfig,
    sourceConfig,
    onSinkConfigChanged,
    onSourceConfigChanged,
    onApiSourceConfigChanged,
  };
}
